import { render } from "./Upload.vue?vue&type=template&id=b3de1688&ts=true"
import script from "./Upload.vue?vue&type=script&lang=tsx"
export * from "./Upload.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__